export default {
  data: () => ({

    rawData:  [],
    
    table: null,
    columns: null,
    keys: null,
    filters: null,
    
    canvasForms:  null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}